<template>
  <div class="company-switcher">
    <router-link class="header-link" to="/">
      <h1 class="title">{{ currentCompanyName }}</h1>
    </router-link>
    <base-toggle-arrow-button
      @click="toggleCompaniesDropdown"
      :section-visible="dropdownVisible"
      v-if="hasMultipleCompanies"
      ref="toggleButtonRef"
    />

    <!-- Dropdown для выбора компании -->
    <div
      v-if="dropdownVisible"
      class="companies-dropdown"
      ref="dropdownRef"
    >
      <div
        class="dropdown-backdrop"
        @click="dropdownVisible = false"
      ></div>
      <div class="dropdown-content">
        <div class="dropdown-header">
          <h4>Выберите компанию</h4>
        </div>
        <ul class="companies-list">
          <li
            v-for="company in companies"
            :key="company.id"
            class="company-item"
            :class="{
              'current-company': company.id === currentCompanyId,
            }"
            @click="handleCompanySwitch(company)"
          >
            <div class="company-info">
              <span class="company-name">{{ company.name }}</span>
              <span class="company-inn">ИНН: {{ company.inn }}</span>
            </div>
            <div
              v-if="company.id === currentCompanyId"
              class="current-indicator"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 48 48"
                  fill="#4caf50"
                >
                  <path
                    fill="#c8e6c9"
                    d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                  />
                  <path
                    d="M34.586,14.586l-13.57,13.586l-5.602-5.586l-2.828,2.828l8.434,8.414l16.395-16.414L34.586,14.586z"
                  />
                </svg>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanySwitcher",
  props: {
    currentCompanyName: {
      type: String,
      required: true,
    },
    companies: {
      type: Array,
      default: () => [],
    },
    currentCompanyId: {
      type: [String, Number],
      required: true,
    },
  },
  emits: ["companySwitch"],
  data() {
    return {
      dropdownVisible: false,
    };
  },
  computed: {
    hasMultipleCompanies() {
      return this.companies && this.companies.length > 1;
    },
  },
  methods: {
    toggleCompaniesDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },

    handleCompanySwitch(company) {
      if (company.id === this.currentCompanyId) {
        this.dropdownVisible = false;
        return;
      }

      this.$emit("companySwitch", company);
      this.dropdownVisible = false;
    },

    handleClickOutside(event) {
      if (!this.dropdownVisible) {
        return;
      }

      const dropdown = this.$refs.dropdownRef;
      const toggleButton = this.$refs.toggleButtonRef?.$el;

      if (
        dropdown &&
        toggleButton &&
        !dropdown.contains(event.target) &&
        !toggleButton.contains(event.target)
      ) {
        this.dropdownVisible = false;
      }
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.company-switcher {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}

.header-link {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-decoration: none;
}

.title {
  font-size: 30px;
  color: var(--color-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.company-switcher :deep(.toggle-btn) {
  flex-shrink: 0;
}

.companies-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin-top: 8px;
}

.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.dropdown-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  min-width: 280px;
  overflow: hidden;
  animation: dropdown-appear 0.2s ease-out;
}

.dropdown-header {
  padding: 15px 10px;
}

.companies-list {
  list-style: none;
  max-height: 300px;
  overflow-y: auto;
}

.company-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-left: 3px solid transparent;
}

.company-item:hover {
  background-color: var(--color-grey);
}

.company-item.current-company {
  border-left-color: var(--color-green);
}

.company-info {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.company-name,
.company-inn {
  font-size: 14px;
}

@keyframes dropdown-appear {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1024px) {
  .title {
    text-align: end;
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 24px;
  }

  .companies-dropdown {
    left: unset;
    right: 0;
  }
}
</style>
